import React, { useEffect, useRef, useState, useContext } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { BsPerson, BsPencilSquare, BsCheckCircleFill } from 'react-icons/bs';
import { LuIndianRupee } from "react-icons/lu";
import { apiRequest } from "../../apiService/allApi";
import Rightcontainer from "../Components/Rightcontainer";
import { MdOutlineLogout } from "react-icons/md";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaUserShield,
  FaCheck,
  FaClock,
  FaArrowRight,
  FaCrown
} from "react-icons/fa";
// Keep your CSS imports
import "../css/layout.css";
import css from "../css/Profile.module.css";
import "../css/kyc.css";
import "../css/Loader.css";

const Profile1 = ({ profile }) => {
  // --- KEEPING ALL YOUR EXISTING LOGIC & STATE UNTOUCHED ---
  const translations = {
    hi: { wallet: 'वॉलेट', refer: 'किसी मित्र का रेफर कोड इस्तेमाल करे', win: 'पैसा जिता', game: 'गेम खेला', referEarn: 'रेफरल कमाई', referPerson: 'आमंत्रित किये दोस्त' },
    en: { wallet: 'My Wallet', refer: 'Use Refer Code', Win: 'Coin Won', game: 'Battle Played', referEarn: 'Referral Earning', referPerson: 'Referred Players' },
  };

  const { language } = useContext(LanguageContext);
  const baseUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const handleClose = () => setShow1(false);
  const handleShow = () => setShow1(true);
  const [referral, setCode] = useState("");
  const [Id, setId] = useState(null);
  const [msg, setMsg] = useState("");
  const [portcss, setPortcss] = useState(css.active_tab);
  const [portcss1, setPortcss1] = useState(css.inactive_tab);
  const [holder_name, setHolder_name] = useState();
  const [account_number, setAccount_number] = useState();
  const [ifsc_code, setIfsc_code] = useState();
  const [upi_id, setUpi_id] = useState();
  const [isLoading, setIsloading] = useState(false);
  const [showKyc, setShowKyc] = useState(false);
  const [process1, setProcesss] = useState(false);

  const udata = localStorage.getItem("udata");
  const profileData = JSON.parse(udata);
  const siteData = localStorage.getItem("sitSetting");
  const SData = JSON.parse(siteData);
  const handleCloseKyc = () => setShowKyc(false);
  const handleShowKyc = () => setShowKyc(true);
  const [inputOpen, setInputOpen] = useState(false);
  const [Email, setEmail] = useState(null);
  const toggleInput = () => setInputOpen(!inputOpen);
  const history = useHistory();
  const location = useLocation();
  // --- ALL YOUR FUNCTIONS (NOT MODIFIED) ---
  const logout = async () => {
    localStorage.clear();
    let access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    await apiRequest(`me`, "GET", null, headers)
      .then(() => { /* logic */ })
      .catch((e) => {
        if (e.response?.status === 401) {
          localStorage.removeItem("token");
          window.location.reload();
          history.push("/login");
        }
      });
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    if (params.get("kyc") === "true") {
      setShowKyc(true);
    }
  }, [location.search]);

  const UpdateEmail = async () => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    if (Email != null) {
      try {
        const respone = await apiRequest(`user/profile/edit`, "PATCH", { Email }, headers);
        if (respone.data.status === false) {
          Swal.fire({ title: respone.data.msg, icon: "error" });
        } else {
          setEmail(respone.data); setInputOpen(false);
          Swal.fire({ title: respone.data.msg, icon: "success" });
        }
      } catch (error) { }
    } else {
      Swal.fire({ title: "Please enter your Email", icon: "error" });
    }
  };

  const [Name, setName] = useState(null);
  const UpdateProfile = async () => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    if (Name != null) {
      const respone = await apiRequest(`user/profile/edit`, "PATCH", { Name }, headers);
      if (respone.data.status === false) {
        Swal.fire({ title: respone.data.msg, icon: "error" });
      } else {
        setName(respone.data);
        Swal.fire({ title: respone.data.msg, icon: "success" });
      }
    }
  };

  const [total, setTotal] = useState();
  const TotalGame = async () => {
    let access_token = localStorage.getItem("token");
    let userId = localStorage.getItem("userId");
    const headers = { Authorization: `Bearer ${access_token}` };
    try {
      const res = await apiRequest(`total/user/all/${userId}`, "GET", null, headers);
      if (res.data) setTotal(res.data);
    } catch (e) { }
  };

  const Result = async (file) => {
    if (file) {
      const access_token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${access_token}` };
      const formData = new FormData();
      formData.append("avatar", file);
      await apiRequest(`users/me/avatar`, "POST", formData, headers);
    }
  };

  const Kyc = () => setShowKyc(true);

  const [AadharNum, setAadharNum] = useState("");
  const [userAdharData, setUserAdharData] = useState("");
  const handleAdharChnage = (e) => setAadharNum(e.target.value);

  const AdharNumber = async (e) => {
    setIsloading(true); e.preventDefault();
    if (/^[0-9]{12}$/.test(AadharNum)) {
      const access_token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${access_token}` };
      const data = { aadharNumber: AadharNum };
      try {
        const res = await apiRequest("aadharcard-auto", "POST", data, headers);
        setUserAdharData(res?.data);
        setIsloading(false);
        if (res.data.status === false) setMsg(res?.data?.msg);
        else setMsg(res?.data?.data?.message);
      } catch (error) { console.log(error); }
    } else {
      Swal.fire({ icon: "error", title: "Invalid Aadhar", text: "12-digit required" });
      setIsloading(false);
    }
  };

  const [AadharOtp, setAadharOtp] = useState("");
  const [isLoading1, setIsloading1] = useState(false);
  const handleAdharOtpChnage = (e) => setAadharOtp(e.target.value);

  const AdharOtpFunc = async (e) => { // Renamed slightly to avoid collision with state
    setIsloading1(true);
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    const data = { aadharNumber: AadharNum, otp: AadharOtp, Email: Email, request_id: userAdharData?.request_id, };
    try {
      const res = await apiRequest(`aadharcard-auto-verify`, "POST", data, headers);
      setIsloading1(false);
      if (res.data.status === false) setMsg(res.data?.msg);
      else window.location.reload();
    } catch (e) { console.log(e); }
  };

  let aadharProcess = useRef(false);
  const [Names, setNames] = useState("");
  const [DOB, setDob] = useState("");
  const [frontLoaded, setFrontLoaded] = useState(null);
  const [backLoaded, setBackLoaded] = useState(null);

  const handleSubmitdata = async (e) => {
    e.preventDefault();
    if (!Names || !DOB || !frontLoaded || !backLoaded || !AadharNum) {
      alert("All fields required"); return;
    }
    if (aadharProcess.current === false) {
      setProcesss(true); aadharProcess.current = true;
      const formData = new FormData();
      formData.append("Name", Names); formData.append("DOB", DOB);
      formData.append("front", frontLoaded[0]); formData.append("back", backLoaded[0]);
      formData.append("Number", AadharNum); formData.append("Email", Email);
      const access_token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${access_token}` };
      const res = await apiRequest(`aadharcard`, "POST", formData, headers);
      if (res.data.status === false) {
        Swal.fire({ title: res.data.msg, icon: "error" }).then(() => handleCloseKyc());
      } else {
        Swal.fire({ title: "KYC submitted", icon: "success" }).then(() => handleCloseKyc());
        history.push("/Profile");
      }
      aadharProcess.current = false; setProcesss(false);
    }
  };

  useEffect(() => { TotalGame(); }, []);

  const [isValidEmail, setIsValidEmail] = useState(true);
  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    setIsValidEmail(emailRegex.test(newEmail) && newEmail.toLowerCase().endsWith(".com"));
  };

  const theme = localStorage.getItem('theme');
  const styles = {
    backgroundColor: theme === 'light' ? '#f0f2f5' : '#0f0f1b',
    color: theme === 'light' ? '#333' : '#fff',
  };

  // --- NEW UI RENDERING ---
  return (
    <>
      <div className="prince_profile_page">

        {/* =====================================================
      PROFILE HERO
  ====================================================== */}

        <section className="prince_profile_hero">

          <div className="prince_hero_blob prince_blob_one"></div>
          <div className="prince_hero_blob prince_blob_two"></div>

          <div className="prince_hero_top">

            {/* AVATAR */}

            <div className="prince_avatar_area">

              <label className="prince_avatar_picker">

                <input
                  type="file"
                  accept="image/*"
                  className="d-none"
                  onChange={(e) => Result(e.target.files[0])}
                />

                <div className="prince_avatar_ring">

                  <div className="prince_avatar_holder">

                    <img
                      src={
                        profileData?.avatar
                          ? `${baseUrl}/${profileData.avatar}`
                          : "./profile-avtar.png"
                      }
                      alt="Player"
                    />

                  </div>

                </div>

                <span className="prince_avatar_edit">
                  <BsPencilSquare />
                </span>

              </label>

            </div>


            {/* USER */}

            <div className="prince_identity">

              {portcss === css.active_tab ? (

                <>
                  <div className="prince_name_line">

                    <h1>
                      {profile?.Name || "Player"}
                    </h1>

                    <button
                      type="button"
                      onClick={() => {
                        setPortcss(css.inactive_tab);
                        setPortcss1(css.active_tab);
                      }}
                    >
                      <BsPencilSquare />
                    </button>

                  </div>

                  <div className="prince_elite_badge">
                    <span>★</span>
                    ELITE PLAYER
                  </div>

                  <p>
                    Your gaming profile
                  </p>
                </>

              ) : (

                <div className="prince_name_editor">

                  <input
                    type="text"
                    value={Name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Enter player name"
                  />

                  <button
                    type="button"
                    onClick={() => {
                      setPortcss(css.active_tab);
                      setPortcss1(css.inactive_tab);
                      UpdateProfile();
                    }}
                  >
                    <BsCheckCircleFill />
                  </button>

                </div>

              )}

            </div>


            {/* KYC */}

            <div className="prince_top_kyc">

              {profile?.verified === "verified" ? (

                <div className="prince_kyc_verified">

                  <div className="prince_kyc_circle">
                    ✓
                  </div>


                  <strong>VERIFIED</strong>

                </div>

              ) : (

                <div
                  className="prince_kyc_unverified"
                  onClick={Kyc}
                >

                  <div className="prince_kyc_circle">
                    !
                  </div>

                  <div>
                    {/* <small>ACCOUNT</small> */}
                    <strong>VERIFY</strong>
                  </div>

                </div>

              )}

            </div>

          </div>


          {/* HERO BOTTOM */}

          <div className="prince_hero_footer">

            <span></span>

            <div>
              <i>✦</i>
              PRINCE LUDO
              <i>✦</i>
            </div>

            <span></span>

          </div>

        </section>


        {/* =====================================================
      PERFORMANCE
  ====================================================== */}

        <section className="prince_performance_section">

          <div className="prince_section_title">

            <div>
              <small>YOUR JOURNEY</small>
              <h2>Player Performance</h2>
            </div>

            <div className="prince_title_icon">
              ✦
            </div>

          </div>


          <div className="prince_stats_grid">

            {/* GAMES */}

            <div className="prince_stat_card prince_games_card">

              <div className="prince_stat_top">

                <div className="prince_stat_icon">

                  <img
                    src="/images/crossswords.png"
                    alt="Games"
                  />

                </div>

                <span className="prince_stat_tag">
                  GAMES
                </span>

              </div>

              <div className="prince_stat_info">

                <small>
                  {translations[language].game}
                </small>

                <strong>
                  {String(total?.stringValue ?? total ?? "0")}
                </strong>

                <span>
                  TOTAL BATTLES
                </span>

              </div>

              <div className="prince_stat_decor">
                ⚔
              </div>

            </div>


            {/* WINNINGS */}

            <div className="prince_stat_card prince_winning_card">

              <div className="prince_stat_top">

                <div className="prince_stat_icon">

                  <img
                    src="../images/troffee.png"
                    alt="Winning"
                  />

                </div>

                <span className="prince_stat_tag">
                  REWARDS
                </span>

              </div>

              <div className="prince_stat_info">

                <small>
                  {translations[language].Win}
                </small>

                <strong>
                  ₹{String(profile?.wonAmount?.stringValue ?? "0")}
                </strong>

                <span>
                  TOTAL COINS WON
                </span>

              </div>

              <div className="prince_stat_decor">
                ₹
              </div>

            </div>

          </div>

        </section>


        {/* =====================================================
      PERSONAL INFORMATION
  ====================================================== */}

        <section className="prince_information_card">

          <div className="prince_information_header">

            <div className="prince_information_heading">

              <div className="prince_heading_badge">
                <FaCrown />
              </div>

              <div>
                <small>ACCOUNT SETTINGS</small>
                <h2>Personal Information</h2>
              </div>

            </div>

            <div className="prince_header_spark">
              ✦
            </div>

          </div>


          {/* PHONE */}

          <div className="prince_info_item">

            <div className="prince_info_color prince_phone_color">
              <FaPhoneAlt />
            </div>

            <div className="prince_info_content">

              <span>PHONE NUMBER</span>

              <strong>
                {profile?.Phone}
              </strong>

            </div>

            <div className="prince_active_badge">
              <span></span>
              Active
            </div>

          </div>


          {/* EMAIL */}

          <div className="prince_info_item">

            <div className="prince_info_color prince_email_color">
              <FaEnvelope />
            </div>

            <div className="prince_info_content">

              <span>EMAIL ADDRESS</span>

              <strong>
                {profile?.Email || "Email not added"}
              </strong>

            </div>

            <button
              type="button"
              className="prince_edit_button"
              onClick={toggleInput}
            >
              <BsPencilSquare />
            </button>

          </div>


          {/* EMAIL EDIT */}

          {inputOpen && (

            <div className="prince_email_editor">

              <div className="prince_editor_heading">
                <FaEnvelope />
                Update your email address
              </div>

              <div className="prince_editor_controls">

                <input
                  type="email"
                  value={Email}
                  onChange={handleEmailChange}
                  placeholder="Enter new email address"
                />

                <button
                  type="button"
                  onClick={UpdateEmail}
                >
                  SAVE
                </button>

              </div>

            </div>

          )}


          {/* KYC */}

          <div
            className={`prince_kyc_banner ${profile?.verified === "verified"
              ? "prince_kyc_done"
              : profile?.verified === "pending"
                ? "prince_kyc_waiting"
                : "prince_kyc_needed"
              }`}

            onClick={
              profile?.verified === "verified" ||
                profile?.verified === "pending"
                ? null
                : Kyc
            }

            style={{
              cursor:
                profile?.verified === "verified" ||
                  profile?.verified === "pending"
                  ? "default"
                  : "pointer"
            }}
          >

            <div className="prince_kyc_banner_icon">

              <FaUserShield />

            </div>


            <div className="prince_kyc_banner_content">

              <small>IDENTITY VERIFICATION</small>

              <strong>
                {profile?.verified === "verified"
                  ? "Your account is verified"
                  : profile?.verified === "pending"
                    ? "Verification is pending"
                    : "Complete KYC verification"}
              </strong>

              <span>
                {profile?.verified === "verified"
                  ? "Your identity has been successfully verified."
                  : profile?.verified === "pending"
                    ? "Your documents are currently under review."
                    : "Verify your identity for a safer gaming experience."}
              </span>

            </div>


            {profile?.verified === "verified" ? (

              <div className="prince_kyc_action prince_kyc_check">
                <FaCheck />
              </div>

            ) : profile?.verified === "pending" ? (

              <div className="prince_kyc_action prince_kyc_pending_icon">
                <FaClock />
              </div>

            ) : (

              <div className="prince_kyc_action prince_kyc_arrow">
                <FaArrowRight />
              </div>

            )}

          </div>

        </section>


        {/* =====================================================
      LOGOUT
  ====================================================== */}

        <section className="prince_logout_area">

          <button
            type="button"
            className="prince_logout_button"
            onClick={logout}
          >

            <div className="prince_logout_icon">
              <MdOutlineLogout />
            </div>

            <div className="prince_logout_text">
              <strong>Logout from account</strong>
              <span>Sign out securely from Prince Ludo</span>
            </div>

            <div className="prince_logout_arrow">
              →
            </div>

          </button>

        </section>


        {/* =====================================================
      KYC MODAL
  ====================================================== */}

        <Modal
          show={showKyc}
          onHide={handleCloseKyc}
          centered
          className="prince_kyc_modal"
        >

          <Modal.Header
            closeButton
            className="prince_modal_header"
          >

            <div className="prince_modal_title_area">

              <div className="prince_modal_icon">
                <img
                  src="/images/kyc.png"
                  alt="KYC"
                />
              </div>

              <div>
                <small>PRINCE LUDO</small>

                <Modal.Title>
                  Verification Center
                </Modal.Title>
              </div>

            </div>

          </Modal.Header>


          <Modal.Body className="prince_modal_body">

            {/* TABS */}

            <ul
              className="nav nav-pills prince_kyc_tabs"
              id="kycTab"
              role="tablist"
            >

              {SData?.onlineKYC && (

                <li className="nav-item flex-fill">

                  <button
                    className="nav-link active w-100"
                    id="online-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#online"
                    type="button"
                  >
                    ONLINE KYC
                  </button>

                </li>

              )}


              {SData?.offlineKYC && (

                <li className="nav-item flex-fill">

                  <button
                    className="nav-link w-100"
                    id="offline-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#offline"
                    type="button"
                  >
                    OFFLINE KYC
                  </button>

                </li>

              )}

            </ul>


            <div className="tab-content prince_modal_content">

              {/* ONLINE */}

              {SData.onlineKYC && (

                <div
                  className="tab-pane fade show active"
                  id="online"
                >

                  <div className="prince_form_group">

                    <label>
                      AADHAR NUMBER
                    </label>

                    <input
                      type="number"
                      value={AadharNum}
                      onChange={handleAdharChnage}
                      placeholder="Enter 12 digit Aadhar number"
                    />

                    <p>
                      {msg}
                    </p>

                  </div>


                  {isLoading ? (

                    <div className="prince_loading_box">

                      <img
                        src="/images/LandingPage_img/loader1.gif"
                        width="40"
                        alt="Loading"
                      />

                      <span>
                        Processing your verification...
                      </span>

                    </div>

                  ) : (

                    !userAdharData?.request_id && (

                      <button
                        type="button"
                        className="prince_modal_submit"
                        onClick={AdharNumber}
                      >
                        SEND OTP
                        <span>→</span>
                      </button>

                    )

                  )}


                  {userAdharData?.request_id && (

                    <div className="prince_otp_box">

                      <div className="prince_form_group">

                        <label>
                          VERIFICATION OTP
                        </label>

                        <input
                          type="number"
                          value={AadharOtp}
                          onChange={handleAdharOtpChnage}
                          placeholder="Enter OTP"
                        />

                      </div>

                      <button
                        type="button"
                        className="prince_modal_submit"
                        onClick={AdharOtpFunc}
                      >
                        VERIFY OTP
                        <span>✓</span>
                      </button>

                    </div>

                  )}

                </div>

              )}


              {/* OFFLINE */}

              {SData.offlineKYC && (

                <div
                  className="tab-pane fade"
                  id="offline"
                >

                  <div className="prince_offline_form">

                    <div className="prince_form_group">

                      <label>
                        FULL NAME
                      </label>

                      <input
                        type="text"
                        value={Names}
                        onChange={(e) =>
                          setNames(e.target.value)
                        }
                        placeholder="Enter full name"
                      />

                    </div>


                    <div className="prince_form_group">

                      <label>
                        AADHAR NUMBER
                      </label>

                      <input
                        type="text"
                        value={AadharNum}
                        onChange={handleAdharChnage}
                        placeholder="Enter Aadhar number"
                      />

                    </div>


                    <div className="prince_form_group">

                      <label>
                        DATE OF BIRTH
                      </label>

                      <input
                        type="date"
                        value={DOB}
                        onChange={(e) =>
                          setDob(e.target.value)
                        }
                      />

                    </div>


                    <div className="prince_upload">

                      <div className="prince_upload_icon">
                        ↑
                      </div>

                      <div className="prince_upload_text">

                        <strong>
                          AADHAR FRONT
                        </strong>

                        <span>
                          Upload front side
                        </span>

                      </div>

                      <input
                        type="file"
                        onChange={(e) =>
                          setFrontLoaded(e.target.files)
                        }
                        accept="image/*"
                      />

                    </div>


                    <div className="prince_upload">

                      <div className="prince_upload_icon">
                        ↑
                      </div>

                      <div className="prince_upload_text">

                        <strong>
                          AADHAR BACK
                        </strong>

                        <span>
                          Upload back side
                        </span>

                      </div>

                      <input
                        type="file"
                        onChange={(e) =>
                          setBackLoaded(e.target.files)
                        }
                        accept="image/*"
                      />

                    </div>


                    <button
                      type="button"
                      className="prince_modal_submit"
                      onClick={handleSubmitdata}
                    >
                      SUBMIT VERIFICATION
                      <span>✓</span>
                    </button>

                  </div>

                </div>

              )}

            </div>

          </Modal.Body>

        </Modal>

      </div>

      <div className="rightContainer">
        <Rightcontainer />
      </div>

      <style dangerouslySetInnerHTML={{
        __html: `
        .premium_card { background: #1a1a2e; border-radius: 15px; position: relative; overflow: hidden; border: 1px solid #2a2a45; box-shadow: 0 10px 30px rgba(0,0,0,0.5); }
        .card_accent { position: absolute; top:0; left:0; width: 100%; height: 4px; background: linear-gradient(90deg, #f39c12, #e67e22); }
        .main_profile_img { width: 70px; height: 70px; border-radius: 50%; border: 3px solid #f39c12; object-fit: cover; }
        .camera_badge { position: absolute; bottom: 0; right: 0; background: #f39c12; border-radius: 50%; padding: 4px; border: 2px solid #1a1a2e; }
        .profile_name_text { font-size: 1.2rem; font-weight: 700; color: #fff; margin-left: 10px; }
        .badge_verified { background: rgba(46, 204, 113, 0.2); color: #2ecc71; border: 1px solid #2ecc71; padding: 4px 10px; border-radius: 20px; font-size: 10px; font-weight: 800; }
        .badge_pending { background: rgba(231, 76, 60, 0.2); color: #e74c3c; border: 1px solid #e74c3c; padding: 4px 10px; border-radius: 20px; font-size: 10px; font-weight: 800; cursor:pointer; }
        .stats_grid_premium { display: grid; grid-template-columns: 1fr 1fr; gap: 15px; }
        .stat_item { background: #1a1a2e; padding: 15px; border-radius: 12px; display: flex; align-items: center; border: 1px solid #2a2a45; }
        .stat_item img { width: 35px; height: 35px; margin-right: 12px; }
        .stat_label { font-size: 10px; color: #888; text-transform: uppercase; display: block; }
        .stat_val { font-size: 1.1rem; font-weight: 800; margin: 0; color: #fff; }
        .blue_glow { border-left: 4px solid #3498db; }
        .gold_glow { border-left: 4px solid #f1c40f; }
        .green_glow { border-left: 4px solid #2ecc71; }
        .purple_glow { border-left: 4px solid #9b59b6; }
        .account_details_card { background: #000; border-radius: 15px; border: 1px solid #2a2a45; }
        .section_title { font-size: 0.9rem; font-weight: 700; color: #f39c12; text-transform: uppercase; margin-bottom: 15px; }
        .detail_row { padding: 12px 0; border-bottom: 1px solid #2a2a45; }
        .row_icon { width: 40px; height: 40px; background: #252545; border-radius: 10px; display: flex; align-items: center; justify-content: center; }
        .row_content label { font-size: 10px; color: #888; margin:0; }
        .row_content p { font-size: 14px; color: #fff; margin:0; font-weight: 600; }
        .modern_input { background: #ffff; border: 1px solid #2a2a45; color: #000; padding: 10px; border-radius: 8px; width: 100%; outline: none; transition: 0.3s; }
        .modern_input:focus { border-color: #f39c12; box-shadow: 0 0 10px rgba(243, 156, 18, 0.2); }
        .premium_logout_btn { background: linear-gradient(90deg, #e74c3c, #c0392b); color: #fff; border: none; padding: 12px 40px; border-radius: 30px; font-weight: 800; letter-spacing: 1px; width: 80%; transition: 0.3s; }
        .premium_logout_btn:hover { transform: translateY(-2px); box-shadow: 0 5px 15px rgba(231, 76, 60, 0.4); }
        .modern_tabs .nav-link { background: #0f0f1b; color: #888; border: 1px solid #2a2a45; margin: 0 5px; font-size: 14px; font-weight: 600; }
        .modern_tabs .nav-link.active { background: #f39c12 !important; color: #fff; border-color: #f39c12; }
        .btn_premium_modal { background: #f39c12; color: #fff; border: none; padding: 10px; border-radius: 8px; font-weight: 700; }
        .dark_modal .modal-content { background: #1a1a2e; color: #fff; border: 1px solid #2a2a45; border-radius: 20px; }
        .file_upload_area { border: 2px dashed #2a2a45; padding: 10px; border-radius: 10px; text-align: center; }
        .file_upload_area label { font-size: 12px; color: #f39c12; display: block; }
      `}} />
    </>
  );
};

export default Profile1;


